<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Meeting Details</a>
      </nav>
    </div>

    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-12" v-if="MeetingDetails.name_with_firm_name">
                                    <span class="lead-title">{{MeetingDetails.name_with_firm_name}} - {{MeetingDetails.broker_locality}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6" v-if="MeetingDetails.broker_name">
                                    <span class="enq-title">Broker</span>
                                    <span class="enq-details">{{MeetingDetails.broker_name}}</span>
                                </div>
                                <div class="col-6" v-if="isFromMyMeetings">
                                    <span class="enq-title">Project Name</span>
                                    <span class="enq-details">{{MeetingDetails.project_name}}</span>
                                </div>
                                <div class="col-6" v-if="!isFromMyMeetings">
                                    <span class="enq-title">Campaigns</span>
                                    <span class="enq-details">{{MeetingDetails.campaigns_count}}</span>
                                </div>
                                <div class="col-6" v-if="MeetingDetails.start_date_time">
                                    <span class="enq-title">Start Time</span>
                                    <span class="enq-details">{{MeetingDetails.start_date_time}}</span>
                                </div>
                                <div class="col-6" v-if="MeetingDetails.end_date_time">
                                    <span class="enq-title">End Time</span>
                                    <span class="enq-details">{{MeetingDetails.end_date_time}}</span>
                                </div>
                                <div class="col-6" v-if="MeetingDetails.meeting_type">
                                    <span class="enq-title">Meeting Type</span>
                                    <span class="enq-details">{{MeetingDetails.meeting_type}}</span>
                                </div>
                                  <div class="col-6" v-if="MeetingDetails.categorization">
                                    <span class="enq-title">Categorization</span>
                                    <span class="enq-details">{{MeetingDetails.categorization}}</span>
                                </div>
                              <div class="col-6" v-if="!isFromMyMeetings">
                                <span class="enq-title">App Engagement</span>
                                <span class="enq-details">{{MeetingDetails.app_engagement ? 'Yes' : 'No'}}</span>
                              </div>
                              <div class="col-6" v-if="isFromMyMeetings">
                                <span class="enq-title">Field Executive</span>
                                <span class="enq-details">{{MeetingDetails.field_executive}}</span>
                              </div>
                              <div class="col-6" v-if="MeetingDetails.listing_count && MeetingDetails.app_engagement">
                                <span class="enq-title">No of Resale & Rental Listings</span>
                                <span class="enq-details">{{MeetingDetails.listing_count}}</span>
                              </div>
                              <div class="col-6" v-if="MeetingDetails.lead_count && MeetingDetails.app_engagement">
                                <span class="enq-title">No of Enquiry Count</span>
                                <span class="enq-details">{{MeetingDetails.lead_count}}</span>
                              </div>
                              <div class="col-6" v-if="MeetingDetails.requirement_count && MeetingDetails.app_engagement">
                                <span class="enq-title"> Syndicate Networking Requirement</span>
                                <span class="enq-details">{{MeetingDetails.requirement_count}}</span>
                              </div>
                              <div class="col-6" v-if="MeetingDetails.recorded_audio_url">
                                <span class="enq-title"> Recorded Audio</span>
                                <button class="btn btn-outline btn-sm" @click="view_audio(MeetingDetails.recorded_audio_url)"> View</button>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12" v-if="MeetingDetails.no_app_engagement_comments && !MeetingDetails.app_engagement">
                                <span class="enq-title">Reason of No App Engagement</span>
                                <span class="enq-details">{{MeetingDetails.no_app_engagement_comments}}</span>
                              </div>
                            </div>
                            <div class="row">
                              <!-- <div class="col-12" v-if="MeetingDetails.location">
                                <span class="enq-title">Meeting Location</span>
                                <span class="enq-details">{{MeetingDetails.location}}</span>
                              </div> -->
                              <div class="col-12" v-if="MeetingDetails.location">
                                  <span class="enq-title">Meeting location</span>
                                  <read-more more-str="read more"  :text="MeetingDetails.location" link="#" less-str="read less" :max-chars="50"></read-more>
                              </div>
                            </div>
                        </div>
                        <div class="card-footer p-2">
                            <div class="row">
                                 <div class="col-6" v-if="MeetingDetails.rating_to_broker">
                                    <span class="enq-title" >Rating<img src="@/assets/star.svg" alt="" class="ml-1" ></span>
                                    <span class="enq-details">{{MeetingDetails.rating_to_broker}}/5</span>
                                </div>
                                <div class="col-6" v-if="MeetingDetails.rating_by_cp">
                                    <span class="enq-title" >Rating By CP<img src="@/assets/star.svg" alt="" class="ml-1" ></span>
                                    <span class="enq-details">{{MeetingDetails.rating_by_cp}}/5</span>
                                </div>
                                <div class="col-12" v-if="MeetingDetails.approved_by_cp">
                                    <span class="enq-title" >Approved</span>
                                    <span class="enq-details">{{MeetingDetails.approved_by_cp}}</span>
                                </div>
                                <div class="col-12" v-if="MeetingDetails.comment">
                                    <span class="enq-title">Minutes of meeting</span>
                                     <read-more more-str="read more"  :text="MeetingDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                </div>
                                <div class="col-12" v-if="MeetingDetails.minutes_of_meeting">
                                    <span class="enq-title">Minutes of meeting</span>
                                     <read-more more-str="read more"  :text="MeetingDetails.minutes_of_meeting" link="#" less-str="read less" :max-chars="50"></read-more>
                                </div>
                                <div class="col-12" v-if="MeetingDetails.executive_image_url">
                                    <button class="enq-title btn selfie-toggle" @click="toggleSelfieImage">Selfie Image <img src="@/assets/down.svg" height="24" width="24" v-if="!showSelfieImage"/> <img height="24" width="24" src="@/assets/up.svg" v-if="showSelfieImage"/> </button>
                                    <div class="selfie-image" v-show="showSelfieImage">
                                        <img class="selfie-image-background" :src="MeetingDetails.executive_image_url" >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            <div class="card-btn">
              <div class="row">
                <div class="col-6 pr-2 mb-3" v-if="!isFromMyMeetings">
                  <router-link class="btn btn-white btn-block" :class="MeetingDetails.campaigns_count===0 ? 'disabled' : ''" :to="{ name: 'ManageMeetingCampaign', params: { id: queryP.id }}">
                    <img src="@/assets/right-arrow.svg" alt="" class="right-arrow">
                    <span class="enq-title">Total Campaigns</span>
                    <span class="enq-details text-link">{{MeetingDetails.campaigns_count}}</span>
                  </router-link>
                </div>
                <div class="col-6 pl-2 mb-3">
                  <router-link class="btn btn-white btn-block" :to="{ name: 'EditMeeting', params: { id: MeetingDetails.id }}">
                    <span class="center-fix">
                      <img src="@/assets/edit-orange.svg" alt="" class="mr-1\" />Edit
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
</div>
</template>
<script>
export default {
  name: 'MeetingDetails',
  data() {
    return {
      AllProjectsOfThisMeetings: [],
      MeetingDetails: {},
      queryP: {},
      showSelfieImage:false,
      isFromMyMeetings: false,
    }
  },
  created () {
    this.isFromMyMeetings = JSON.parse(sessionStorage.getItem("isFromMyMeetings"));
    this.FetchMeetingDetails()
  },
  methods: {
    view_audio(audio) {
      window.open(audio);
    },
    FetchMeetingDetails() {
      this.queryP['id'] = this.$route.params.id;
      if(!this.isFromMyMeetings) {
        this.$axios.get(`users/meetings/${this.queryP.id}/meeting_detail`, { params: this.queryP }).then((res) => {
          this.MeetingDetails =  res.data.meeting
          this.MeetingDetails['campaigns_count'] = res.data.campaigns_count
          if (this.MeetingDetails.interested_in_resale_or_rental === true) {
            this.MeetingDetails.interested_in_resale_or_rental = 'Yes'
          } else {
            this.MeetingDetails.interested_in_resale_or_rental = 'No'
          }
        });
      } else {
        this.$axios.get(`/enquiries/client_meetings/${this.queryP.id}/client_meeting_detail?id=${this.queryP.id}`).then((res) => {
          this.MeetingDetails = res.data.client_meeting;
        });
      }
    },
    toggleSelfieImage(){
        this.showSelfieImage = !this.showSelfieImage;
    }
  }
}
</script>
<style scoped>
    .inner-page{
        margin-top: 60px;
    }
    .selfie-image{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-outline {
      padding: 12px;
      color: #19a7ce;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.56px;
      display: flex;
      gap: 6px;
      justify-content: center;
      align-items: center;
      width: 50%;
      border-radius: 34px;
      border: 1px solid #19a7ce;
      background: #fff;
    }

    .selfie-toggle{
        padding-left: 0;
    }
    .selfie-image-background{
        background: url('~@/assets/no-avatar.svg') no-repeat 0px center  #fff;
        min-height: 100px;
        min-width: 100px;
    }
</style>